<style src="./Volume.scss" lang="scss"></style>

<template lang="pug">
  .volume(
    :class='dragging && "is-dragging"'
  )
    button.volume__indicator(
      @click='mute'
    )
      Icon(
        :name="currentState.icon"
      )
    .volume__line(
      ref='line'
      @mousedown='(e) => offset(e, "click")'
      v-dragged='(e) => offset(e, "drag")'
    )
      .volume__level(
        :style='`width: ${volume}%`'
      )
      .volume__point(
        :style='`left: ${volume}%`'
      )
</template>

<script>
import Icon from "@/components/Icon/Icon";
import Helpers from "@/services/helpers";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      position: 50,
      prevPosition: 50,
      drag: 0,
      dragging: false,
      lineWidth: 0,
      muted: false,
      states: [
        { value: 0, icon: "volumeMute" },
        { value: 1, icon: "volumeMin" },
        { value: 50, icon: "volumeHalf" },
        { value: 90, icon: "volumeFull" }
      ]
    };
  },
  computed: {
    ...mapGetters({
      volume: "player/volume"
    }),
    level() {
      const position = this.position + this.drag;
      const percent = (position / this.lineWidth) * 100;
      const value = percent < 0 ? 0 : percent > 100 ? 100 : percent;

      return value;
    },
    currentStateIndex() {
      return Helpers.closestValueIndex(this.states, this.level);
    },
    currentState() {
      return this.states[this.currentStateIndex];
    }
  },
  watch: {
    position(value) {
      if (value > this.lineWidth) {
        this.position = this.lineWidth;
      }
      if (value < 0) {
        this.position = 0;
      }
    },
    level(value) {
      this.muted = value < 1;
    }
  },
  components: {
    Icon
  },
  methods: {
    mute() {
      if (this.muted) {
        this.position = this.prevPosition;
      } else {
        this.prevPosition = this.position;
        this.position = 0;
      }

      this.$player.setVolume(this.level);
    },
    offset({ offsetX, first, last }, type) {
      if (type === "drag") {
        if (first) {
          this.dragging = true;
        }
        if (first || last) {
          this.position = this.position + this.drag;
          this.drag = 0;
        } else {
          this.drag = offsetX;
        }
        if (last) {
          this.dragging = false;
        }
      }

      if (type === "click") {
        this.position = offsetX;
      }

      const level = Math.trunc(this.level);

      this.$player.setVolume(level);
    }
  },
  mounted() {
    this.lineWidth = this.$refs.line.clientWidth;
    this.position = this.volume;
  }
};
</script>
